import Swiper from 'swiper';
import { Navigation, Keyboard, A11y } from 'swiper/modules';

class TeamSlider {
  constructor() {
    TeamSlider.init();
  }

  static init() {
    [].forEach.call(window.wrapper.querySelectorAll('.block--team__slider'), (slider) => {
      const { id } = slider.dataset;
      const nextEl = slider.querySelector(`[data-prev="${id}"]`);
      const prevEl = slider.querySelector(`[data-next="${id}"]`);

      return new Swiper(slider, {
        modules: [Navigation, Keyboard, A11y],
        slidesPerView: 1,
        grabCursor: true,
        spaceBetween: 20,
        speed: 600,
        touchRatio: 0.85,
        navigation: {
          nextEl,
          prevEl
        },
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 30
          }
        }
      });
    });
  }
}

export default TeamSlider;
